import {Navbar} from "react-bootstrap";
import Container from "react-bootstrap/Container";
import {Link} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBackspace} from "@fortawesome/free-solid-svg-icons";
import {LazyLoadImage} from "react-lazy-load-image-component";
import React from "react";

const Header2 = React.memo(
	() => {
		return (
			<div className={''}>
				<Navbar expand="md" className="mb-0 ck pc os app-navbar top-nav specific-nav top-section-page" fixed="top"
						variant="dark" style={{paddingLeft: '0px', paddingBottom: '0px'}}>
					<Container fluid
							   className={'d-flex justify-content-between mobile-change top-login-background-img'}>
						<Navbar.Brand className="e logo align-self-start menu-control d-flex w-100 " title="Betnare"
									  style={{paddingLeft: '0px', paddingBottom: '0px'}}>
							<Link to={'/'} className={'betnare-text-light'}>
								<FontAwesomeIcon icon={faBackspace}/> Home
							</Link>

							<div
								className="col-md-6  d-flex  right justify-content-end align-items-center w-change3 gap-2 top-login-background-img-bg-page"
								style={{marginLeft: 'auto'}}>

								<Link to={{pathname: "/"}} className=" resize-mobile">
									<LazyLoadImage src={'https://cdn.betnare.com/logo-white.webp'} alt="Betnare" title="Betnare" effects="blur"
												   className={"image-size "}/>
								</Link>
							</div>
						</Navbar.Brand>
					</Container>
				</Navbar>
			</div>
		)
	})

export default React.memo(Header2);
